import { Marca } from './Marca';
import { ReporteProductosInformacion } from './ReporteProductosInformacion';


export class ReporteMarcasProductos {
    marca:Marca;
    productos:ReporteProductosInformacion[];
    total: number;
}